import axios from 'shared/lib/axios'
import { flashSuccessMessage, flashErrorMessage } from 'redux-flash'

export const ACCOUNT_DETAIL_FETCH = 'ACCOUNT_DETAIL_FETCH'
export const ACCOUNT_DETAIL_RESPONSE = 'ACCOUNT_DETAIL_RESPONSE'
export const CREATE_NEW_ACCOUNT_SUBMIT = 'CREATE_NEW_ACCOUNT_SUBMIT'
export const CREATE_NEW_ACCOUNT_RESPONSE = 'CREATE_NEW_ACCOUNT_RESPONSE'
export const DELETE_ACCOUNT_SUBMIT = 'DELETE_ACCOUNT_SUBMIT'
export const DELETE_ACCOUNT_RESPONSE = 'DELETE_ACCOUNT_RESPONSE'
export const UPDATE_ACCOUNT_ROLE_SUBMIT = 'UPDATE_ACCOUNT_ROLE_SUBMIT'
export const UPDATE_ACCOUNT_ROLE_RESPONSE = 'UPDATE_ACCOUNT_ROLE_RESPONSE'

export function accountDetailResponse(json) {
  return { type: ACCOUNT_DETAIL_RESPONSE, payload: json.data }
}

export function createAccountResponse(json) {
  return { type: CREATE_NEW_ACCOUNT_RESPONSE, stats: json.data }
}

export function accountDetailFetch(uuid) {
  const params = { retailer_id: uuid }

  return (dispatch) => {
    axios
      .get('/api/partner-accounts', { params })
      .then((json) => dispatch(accountDetailResponse(json)))
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.log(err)
      })
  }
}

// Page-local, so it stays out of the accounts reducer and its store shape.
export function fetchPendingInvitations(uuid) {
  const params = { retailer_id: uuid }

  return () =>
    axios
      .get('/api/partner-rest/retailer-invitations', { params })
      .then((json) => json.data)
      // An unreadable list is not worth a banner over the page it sits on;
      // the accounts table beside it still rendered.
      .catch(() => [])
}

export function revokeInvitation({ invitationUuid, retailerUuid }) {
  return (dispatch) =>
    axios
      .delete(`/api/partner-rest/retailer-invitations/${invitationUuid}`, {
        params: { retailer_id: retailerUuid },
      })
      .then((response) => {
        dispatch(flashSuccessMessage('Invitation revoked.'))
        return response
      })
      .catch((err) => {
        dispatch(
          flashErrorMessage(
            err.response?.data?.message || 'Unable to revoke invitation.'
          )
        )
      })
}

export function createAccount(values) {
  return (dispatch) => {
    const payload = {
      first_name: values.first_name,
      last_name: values.last_name,
      email: values.email,
      password: values.password,
      role_id: values.role_id,
      ...values,
    }
    return axios
      .post('/api/create_account', payload)
      .then((json) => {
        dispatch(createAccountResponse(json))
        // 202: the address already has an account, so core mailed them an
        // invitation rather than adding them outright.
        dispatch(
          flashSuccessMessage(
            json.status === 202
              ? `Invitation sent to ${values.email}.`
              : 'Successfully created account.'
          )
        )

        return json
      })
      .catch((err) => {
        // The refusals carry the reason the admin needs — an address that
        // belongs to a non-partner account, or one already on this retailer.
        dispatch(
          flashErrorMessage(
            err.response?.data?.message || 'Unable to create account.'
          )
        )
      })
  }
}

export function deleteAccount(payload) {
  return (dispatch) =>
    axios
      .post('/api/remove_account', payload)
      .then((response) => {
        if (response.status === 200) {
          dispatch(flashSuccessMessage('Successfully deleted account.'))
          return response
        }
      })
      .catch((err) => {
        dispatch(
          flashErrorMessage(
            err.response.data.message || 'Sorry unable to delete account.'
          )
        )
      })
}

export function updateAccountRole(payload) {
  return (dispatch) =>
    axios
      .patch('/api/admin-rest/account-role', payload)
      .then((response) => {
        if (response.status === 200) {
          dispatch(flashSuccessMessage('Successfully updated account role.'))
          dispatch({
            type: UPDATE_ACCOUNT_ROLE_RESPONSE,
            payload: response.data,
          })
          return response
        }
      })
      .catch((err) => {
        dispatch(
          flashErrorMessage(
            err.response?.data?.message ||
              'Sorry, unable to update account role.'
          )
        )
        throw err
      })
}
